const axios = require('axios');

const countries = document.querySelectorAll('select[data-address-country]');
if (countries.length) {
    // Use the same country labels and ISO values as the new-site address control.
    axios.get('/api/v2/locale/countries').then(({data}) => {
        countries.forEach(select => {
            const value = select.value;
            const placeholder = select.options[0];
            const options = data.map(country => new Option(country.label, country.value,
                country.value === value, country.value === value));
            // Preserve existing saved values even if they are not ISO country codes.
            if (value && !data.some(country => country.value === value))
                options.unshift(new Option(value, value, true, true));
            select.replaceChildren(placeholder, ...options);
        });
    }).catch(() => {
        // A failed lookup must still allow manual address entry.
        countries.forEach(select => {
            const input = document.createElement('input');
            for (const attribute of select.attributes)
                if (attribute.name !== 'data-address-country') input.setAttribute(attribute.name, attribute.value);
            input.type = 'text';
            input.placeholder = 'Country';
            input.defaultValue = select.value;
            const wrapper = select.parentElement;
            wrapper.replaceWith(input);
        });
    });
}
